import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function AI() {
  const { t } = useI18n();
  const cards = t('ai.cards');
  return (
    <section className="ai-section">
      <div className="fone-top"></div>
      <div className="ai-inner">
        <span className="section-tag">{t('ai.tag')}</span>
        <h2 className="section-title">{t('ai.title')}</h2>
        <div className="ai-grid">
          {Array.isArray(cards) && cards.map((c, i) => (
            <div className="ai-card" key={i}>
              <div className="ai-icon">{c.icon}</div>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
              <div className="example-box" dangerouslySetInnerHTML={{ __html: c.example }} />
            </div>
          ))}
        </div>
      </div>
      <div className="fone-bottom"></div>
    </section>
  );
}